import React from 'react';
import translate from '../../i18n/translate';

/**
 * Auction — explains the perpetual proportional auction mechanism, the EOS
 * empirical precedent ($4.2B raised) and the 70/20/10 split.
 *
 * Copy reused from vision-2-* i18n keys (already aligned with paper v1.4.1).
 */
export default function Auction() {
  return (
    <section className="lv2-section" id="auction" style={{ paddingTop: 0 }}>
      <div className="lv2-shell">
        <div className="lv2-section-head">
          <span className="lv2-section-tag">{translate('vision-ticker-2')}</span>
          <h2>{translate('vision-title-2')}</h2>
        </div>
        <div className="lv2-vision-grid">
          <article className="lv2-vision-card">
            <svg className="lv2-vision-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
              <circle cx="12" cy="12" r="9"/>
              <path d="M12 6v6l4 2"/>
            </svg>
            <span className="lv2-vision-cond">Periods</span>
            <p>{translate('vision-2-1')}</p>
          </article>
          <article className="lv2-vision-card">
            <svg className="lv2-vision-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
              <path d="M3 17l4-4 4 4 4-7 6 7"/>
              <circle cx="3" cy="17" r="1.5"/>
              <circle cx="11" cy="17" r="1.5"/>
              <circle cx="21" cy="17" r="1.5"/>
            </svg>
            <span className="lv2-vision-cond">Allocation</span>
            <p>{translate('vision-2-2')}</p>
          </article>
          <article className="lv2-vision-card">
            <svg className="lv2-vision-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
              <path d="M12 2v20M2 12h20"/>
              <circle cx="12" cy="12" r="9"/>
            </svg>
            <span className="lv2-vision-cond">70 / 20 / 10</span>
            <p>{translate('vision-2-3')}</p>
          </article>
        </div>
      </div>
    </section>
  );
}
